import React, { useState, useEffect, Fragment, useRef } from 'react';
import { useForm, Controller } from 'react-hook-form';
import { Button, Spinner, Col, Row, Form, FormGroup, Label, Input, Alert,
    Nav, NavItem, NavLink, TabContent, TabPane, CustomInput,
    Modal, ModalHeader, ModalBody, ModalFooter, FormFeedback, FormText, Container, ListGroup, ListGroupItem, ListGroupItemHeading, Progress } from 'reactstrap';
import { Prompt, NavLink as RouterNavLink, Link } from 'react-router-dom';
// @ts-ignore
import Select from 'react-select';
// @ts-ignore
import randomstring from "randomstring";
import BlobUtil from '../../utils/blobUtil';

export default function DetailForm({props, read, save, remove, 
    overwriteWarningFlag, overwriteHandleWarning, isNew, positionList}: any) {
  
  const [overwriteFlag, setOverwriteFlag] = useState("false");
  const [removeWarning, setRemoveWarning] = useState(false);
  const toggleRemoveWarning = () => setRemoveWarning(!removeWarning);

  const [eTag, setETag] = useState(""); // Detect changes on data
  const [isSaved, setIsSaved] = useState(false);
  
  const [ _inputFile, setInputFile ] = useState();
  const [ _logoImge, setLogoImage ] = useState(props.data?.orgProfileImgURL);
  const [ _uploadProgress, setUploadProgress ] = useState(0);
  const [ UploadFlag, setUploadFlag] = useState(false);
  const toggleUploadFlag = () => {
    setUploadFlag(!UploadFlag);
  }
  
  const [ _concentrationCategory , setConcentrationCategory ] = useState((props.data?.categories) ? props.data?.categories : []);

  const [ CPFlag, setCPFlag] = useState(false);
  const toggleCPFlag = () => {
    resetState();
    setCPFlag(!CPFlag);
  }

  const [ _categoryName, setCategoryName ] = useState("");
  const [ _picInput, setPicInput ] = useState({
    picInput1: "",
    picInput2: "",
    picInput3: "",
    picInput4: "",
    picInput5: "",
 });

 const [ _picUploadFlag, setPicUploadFlag ] = useState({
    picInput1: true,
    picInput2: true,
    picInput3: true,
    picInput4: true,
    picInput5: true
 });

 const [ _picUploadDoneFlag, setPicUploadDoneFlag ] = useState({
    picInput1: false,
    picInput2: false,
    picInput3: false,
    picInput4: false,
    picInput5: false
 });

  const { register, handleSubmit, reset, watch, errors, formState, control  } = useForm();
  
  // Read the formState before render to subscribe the form state through Proxy
  const { dirty, isSubmitting, isSubmitted, touched, submitCount } = formState;
  
  const onSubmit = (data : any, e: any) => {
    //console.log(data)
    save(data);
    setIsSaved(true);
  };

  const watchFields = watch(["_etag"]);
  if (watchFields){
      if (watchFields._etag !== undefined && props.data?._etag !== undefined && (eTag === "" || eTag != props.data?._etag)){
        setETag(props.data._etag);
        //console.log("_etag updated..." + props.data._etag);
        if (isSaved){ // Reset only if record updated and issubmitted
            //console.log("Call Reset");
            setTimeout(() => {
                reset();
                setIsSaved(false);
            }, 0)
            
        }
      }
  }

  const handleRequestDelete = () => {
    remove(props.data);
    setRemoveWarning(!removeWarning);
  }
  
  const handleReloadData = () => {
    read();
    overwriteHandleWarning();
  }
  
  async function handleUploadAction(event: any) {
    event.preventDefault();

    const { name } = event.target;
    let fileName = '';
    let fileUploadProgressInterval: any;
    let blobUtil = new BlobUtil();

    setUploadProgress(0);

    if (name === "picInput1") fileName = _picInput.picInput1;
    if (name === "picInput2") fileName = _picInput.picInput2;
    if (name === "picInput3") fileName = _picInput.picInput3;
    if (name === "picInput4") fileName = _picInput.picInput4;
    if (name === "picInput5") fileName = _picInput.picInput5;

    if (_inputFile) {
        setUploadFlag(false);
        toggleUploadFlag();
        fileUploadProgressInterval = setInterval(async () => {
            setUploadProgress(blobUtil.getUploadProgress());
        }, 500);

        let blobRequestUrl = await blobUtil.UploadBlobToCointainer3(fileName, _inputFile?.[0], "images");  
        clearInterval(fileUploadProgressInterval);
        setUploadProgress(100);
        setPicUploadFlag({ ..._picUploadFlag, [name]: true});
        setPicUploadDoneFlag({ ..._picUploadDoneFlag, [name]: true});
    }    
    else {
        alert("Please select file first before upload.");
        return ;
    }
  }

  const resetState = () => {
    setCategoryName("");
    setPicUploadFlag({
        picInput1: true,
        picInput2: true,
        picInput3: true,
        picInput4: true,
        picInput5: true
    });
    setPicInput({
        picInput1: "",
        picInput2: "",
        picInput3: "",
        picInput4: "",
        picInput5: ""
    });
  }

  const handleCategoryNameOnChange = (event: any) => {
    setCategoryName(event.target.value);
  }

  const handleImg = (event: any) => {
    event.preventDefault();

    if (event.target.files.length > 0) {
        const { name } = event.target;
        let randomString = randomstring.generate({
            length: 6,
            charset: 'alphanumeric',
            capitalization: 'uppercase'
        });
        let filename = "concentration/" + randomString + ".jpg";
        setPicUploadDoneFlag({ ..._picUploadDoneFlag, [name]: false});
        setPicInput({ ..._picInput, [name]: filename});
        // setPicUploadFlag({ ..._picUploadFlag, [name]: false});
        setPicUploadFlag({
            picInput1: (name === "picInput1") ? false : true,
            picInput2: (name === "picInput2") ? false : true,
            picInput3: (name === "picInput3") ? false : true,
            picInput4: (name === "picInput4") ? false : true,
            picInput5: (name === "picInput5") ? false : true
        });
        setInputFile(event.target.files);
    }
  }

  const addConcentrationCategory = () => {
    let picArray = Object.values(_picInput).filter((e: any) => { return (e !== ""); });

    if (_categoryName === "") {
        alert("Please fill in category name!");
        return ;
    }

    if (picArray.length < 3) {
        alert("At least 3 pictures needed.");
        return ;
    }

    const index :number = _concentrationCategory?.map(function(p: any) { return p.name; }).indexOf(_categoryName);
    if (index < 0) { 
        let newObj: any = {
            id: _concentrationCategory.length + 1,
            name: _categoryName,
            pictures: picArray
        }
        setConcentrationCategory([..._concentrationCategory, newObj]);
    }
    else {
        alert("Category existed!");
    }
    toggleCPFlag();
  }

  const removeConcentrationCategory = (categoryName: any) => {
    if (window.confirm("Are you sure want to remove this cateogry?")) {
        let newCQArr = [..._concentrationCategory];
        const index :number = newCQArr.map(function(p: any) { return p.name; }).indexOf(categoryName);
        if (index !== -1) {
            newCQArr.splice(index, 1);

            //reset each obj id
            newCQArr.forEach((obj: any, index: number) => {
                obj.id = index + 1;
            });

            setConcentrationCategory(newCQArr);
        }
    }
  }
  
  return (
      <Fragment>
        <Form id='DetailsFrom' className="mt-12 mb-12" onSubmit={handleSubmit(onSubmit)}>
            <ListGroup>
                <ListGroupItem>
                    <ListGroupItemHeading>Concentration Information</ListGroupItemHeading>
                    <ListGroupItem>
                        <FormGroup row={true}>
                            <Label for="name" sm={3}>Set Name</Label >
                            <Col lg={6} sm={6}>
                                <Input type="text" name="name" defaultValue={props.data?.name}
                                    innerRef={register({ required: true })} />
                                {errors.name && <FormText color="danger">Required field. Minimum length 10 character.</FormText>}
                            </Col>
                        </FormGroup>
                        <FormGroup row={true}>
                            <Label for="name" sm={3}>Pictures</Label >
                            <Col lg={6} sm={6}>
                                <Button color="primary" onClick={toggleCPFlag} >Add New</Button>
                            </Col>
                        </FormGroup>
                    </ListGroupItem>
                </ListGroupItem>
            </ListGroup>
            <br />
            <ListGroup>
                <ListGroupItem>
                    <ListGroupItemHeading>Concentration Category</ListGroupItemHeading>
                    <ListGroupItem>
                        <Col sm={12}>
                            {
                               _concentrationCategory?.map((obj: any) => 
                                    <div className="row mb-3 pb-3" style={{backgroundColor: "lightgrey"}}>
                                        <Label lg={11} sm={11}><b>{obj.name}</b></Label>
                                        <Button close title="Remove" style={{padding: "3px 15px"}} onClick={() => removeConcentrationCategory(obj.name)}></Button>

                                        <div className="row" style={{width: "100%", margin: 0}} >
                                            <Col lg={12} style={{display: "contents", padding: "10px"}}>
                                                {
                                                    obj.pictures?.map((item: any) => 
                                                        <div style={{width: "200px", textAlign: "center"}}>
                                                            <img 
                                                                src={"https://images.ultimatespro.com/images/" + item.replace(".jpg","_300x300.jpg").replace(".png","_300x300.png")} 
                                                                alt="" 
                                                                width={200}
                                                                height={200}
                                                            />
                                                        </div>
                                                    )
                                                }
                                            </Col>
                                        </div>
                                    </div>
                               )
                            }
                        </Col>
                    </ListGroupItem>
                </ListGroupItem>
            </ListGroup>
            <br />

            <Input type="hidden" name="categories" value={JSON.stringify(_concentrationCategory)} innerRef={register()} />
            <Input type="hidden" name="Overwrite" value={overwriteFlag} innerRef={register()} />
            <Input type="hidden" name="_etag" defaultValue={props.data?._etag}  innerRef={register()} />

            <FormGroup row={true}>
                <Col sm={12}>
                    {
                        !isNew && (
                            <Button color="danger" size="lg" className="float-left" disabled={props.ui.loading || props.ui.processing} 
                                onClick={toggleRemoveWarning}>
                                <i className="fas fa-trash-alt mr-1"></i>&nbsp;Remove
                            </Button>
                        )
                    }
                    <Button type="submit" color="primary" size="lg" className="float-right" disabled={!dirty || props.ui.loading || props.ui.processing} 
                        onClick={() => setOverwriteFlag("false")}>
                        <i className="fas fa-save mr-1"></i>&nbsp;Save
                    </Button>
                    {
                        props.ui.processing && (<Spinner color="warning" className="float-right">&nbsp;</Spinner>)
                    }   
                </Col>
            </FormGroup>
            <Modal isOpen={overwriteWarningFlag} toggle={overwriteHandleWarning}>
                <ModalHeader toggle={overwriteHandleWarning}>Warning</ModalHeader>
                <ModalBody>
                    <p>Record you changing is not the latest version. <br/>
                        Please confirm if you want to :- <br/>
                        1. Overwrite. Update latest data with your changes. <br/>
                        2. Reload. Discarding your current changes.<br/>
                        3. Cancel. Remain your changes.<br/>
                    </p>
                </ModalBody>
                <ModalFooter>                 
                    <Button form="DetailsFrom" type="submit" color="warning" size="lg" className="float-right" 
                        disabled={props.ui.loading || props.ui.processing} 
                        onClick={() => setOverwriteFlag("true")}>
                        <i className="fas fa-save mr-1"></i>&nbsp;Overwrite
                    </Button>
                    <Button color="danger" size="lg" onClick={handleReloadData}>
                        <i className="fas fa-redo-alt mr-1"></i>&nbsp; Reload
                    </Button>
                    <Button color="secondary" size="lg" onClick={overwriteHandleWarning}>
                        <i className="fas fa-times-circle mr-1"></i>&nbsp;Cancel
                    </Button>
                </ModalFooter>
            </Modal> 
            
            <Modal isOpen={removeWarning} toggle={toggleRemoveWarning} >
                <ModalHeader toggle={toggleRemoveWarning}>Warning</ModalHeader>
                <ModalBody>
                    <p>Please confirm to remove this record<br/>
                        Note. This action is irreversible.<br/>
                    </p>
                </ModalBody>
                <ModalFooter>    
                    <Button color="danger" size="lg" onClick={handleRequestDelete}>
                        <i className="fas fa-trash-alt mr-1"></i>&nbsp; Proceed to Remove
                    </Button>
                    <Button color="secondary" size="lg" onClick={toggleRemoveWarning}>
                        <i className="fas fa-times-circle mr-1"></i>&nbsp;Cancel
                    </Button>
                </ModalFooter>
            </Modal> 
            <Modal isOpen={props.ui.processState === 3} backdrop="static" keyboard={false} >
                <ModalHeader>Success</ModalHeader>
                <ModalBody>
                    <p>Succesfully remove!<br/>
                    </p>
                </ModalBody>
                <ModalFooter>    
                    <RouterNavLink to="/concentrations" className="nav-link" exact>
                        <i className="fas fa-list mr-1"></i>Back to Concentration List
                    </RouterNavLink>
                </ModalFooter>
            </Modal> 

            <Modal isOpen={UploadFlag} toggle={toggleUploadFlag}>
                <ModalHeader toggle={toggleUploadFlag}>Upload Progress</ModalHeader>
                <ModalBody>
                    <Progress value={_uploadProgress}>{_uploadProgress}%</Progress>
                </ModalBody>
                <ModalFooter>
                    <Button color="primary" disabled={(_uploadProgress !== 100) ? true : false} onClick={toggleUploadFlag}>Close</Button>
                </ModalFooter>
            </Modal> 

            <Modal size="xl" isOpen={CPFlag} toggle={toggleCPFlag} >
                <ModalHeader toggle={toggleCPFlag}>Concentration Pictures</ModalHeader>
                <ModalBody>
                    <FormGroup row={true} >
                        <Label for="concentrationCategoryName" lg={3} sm={2}>Category</Label >
                        <Col lg={9} sm={10}>
                            <Input type="text" name="concentrationCategoryName" onChange={handleCategoryNameOnChange} innerRef={register({ required: true })} />
                        </Col>
                    </FormGroup>
                    <Label for="concentrationCategoryChoices" className="row" lg={3} sm={2}>Choices:</Label >
                    <FormGroup row={true} >
                        <Col lg={12} style={{display: "flex", justifyContent:"space-between"}}>
                            <div style={{width: "200px"}}>
                                <img 
                                    src={(_picInput.picInput1 && _picUploadDoneFlag.picInput1) ? "https://images.ultimatespro.com/images/" + _picInput.picInput1.replace(".jpg","_xs.jpg") : 
                                    "http://images.ultimatespro.com/images/general/empty_xs.png" } 
                                    alt="" 
                                    width={200}
                                    height={165}
                                />
                                <CustomInput id="1" type="file" name="picInput1" className="mt-2" accept="image/png, image/jpeg, image/jpg" onChange={handleImg} />
                                <Button color="primary" name="picInput1" disabled={_picUploadFlag.picInput1} className="mt-2" onClick={handleUploadAction} style={{width: "100%"}}>Upload</Button>
                            </div>
                            <div style={{width: "200px"}}>
                                <img 
                                    src={(_picInput.picInput2 && _picUploadDoneFlag.picInput2) ? "https://images.ultimatespro.com/images/" + _picInput.picInput2.replace(".jpg","_xs.jpg") : 
                                    "http://images.ultimatespro.com/images/general/empty_xs.png" } 
                                    alt="" 
                                    width={200}
                                    height={165}
                                />
                                <CustomInput id="2" type="file" name="picInput2" className="mt-2" accept="image/png, image/jpeg, image/jpg" onChange={handleImg} />
                                <Button color="primary" name="picInput2" disabled={_picUploadFlag.picInput2} className="mt-2" onClick={handleUploadAction} style={{width: "100%"}}>Upload</Button>
                            </div>
                            <div style={{width: "200px"}}>
                                <img 
                                    src={(_picInput.picInput3 && _picUploadDoneFlag.picInput3) ? "https://images.ultimatespro.com/images/" + _picInput.picInput3.replace(".jpg","_xs.jpg") : 
                                    "http://images.ultimatespro.com/images/general/empty_xs.png" } 
                                    alt="" 
                                    width={200}
                                    height={165}
                                />
                                <CustomInput id="3" type="file" name="picInput3" className="mt-2" accept="image/png, image/jpeg, image/jpg" onChange={handleImg} />
                                <Button color="primary" name="picInput3" disabled={_picUploadFlag.picInput3} className="mt-2" onClick={handleUploadAction} style={{width: "100%"}}>Upload</Button>
                            </div>
                            <div style={{width: "200px"}}>
                                <img 
                                    src={(_picInput.picInput4 && _picUploadDoneFlag.picInput4) ? "https://images.ultimatespro.com/images/" + _picInput.picInput4.replace(".jpg","_xs.jpg") : 
                                    "http://images.ultimatespro.com/images/general/empty_xs.png" } 
                                    alt="" 
                                    width={200}
                                    height={165}
                                />
                                <CustomInput id="4" type="file" name="picInput4" className="mt-2" accept="image/png, image/jpeg, image/jpg" onChange={handleImg} />
                                <Button color="primary" name="picInput4" disabled={_picUploadFlag.picInput4} className="mt-2" onClick={handleUploadAction} style={{width: "100%"}}>Upload</Button>
                            </div>
                            <div style={{width: "200px"}}>
                                <img 
                                    src={(_picInput.picInput5 && _picUploadDoneFlag.picInput5) ? "https://images.ultimatespro.com/images/" + _picInput.picInput5.replace(".jpg","_xs.jpg") : 
                                    "http://images.ultimatespro.com/images/general/empty_xs.png" } 
                                    alt="" 
                                    width={200}
                                    height={165}
                                />
                                <CustomInput id="5" type="file" name="picInput5" className="mt-2" accept="image/png, image/jpeg, image/jpg" onChange={handleImg} />
                                <Button color="primary" name="picInput5" disabled={_picUploadFlag.picInput5} className="mt-2" onClick={handleUploadAction} style={{width: "100%"}}>Upload</Button>
                            </div>
                        </Col>
                    </FormGroup>
                </ModalBody>
                <ModalFooter>
                    <Button color="primary" onClick={addConcentrationCategory}>Save</Button>
                </ModalFooter>
            </Modal>
        </Form>
        <br/><br/>
        <br/>
        {/* <Row>
            <Col lg="12">
                {JSON.stringify(props.data)}
            </Col>
        </Row> */}
        <Prompt when={dirty && !isSubmitted} 
            message="Are you sure want to discard your changes?"
        />
    </Fragment>
    
  );
}